import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import DocumentDropDown from './DocumentDropDown';
import DocumentCheckboxButton from './DocumentCheckboxButton';

const DocumentWrapper = styled<any, any>('li')`
    ${propStyles};
    position: relative;
    list-style: none;
`;

DocumentWrapper.defaultProps = {
    display: "flex",
    flexDirection: "column",
    flex: ["none", "0 0 50%"]
};

const DocumentType = styled<any, any>('div')`
    ${propStyles};
`;

DocumentType.defaultProps = {
    display: "flex",
    flex: "1 0 auto",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginX: "sm",
    marginY: "xs",
    paddingY: "sm",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "none none solid none"
};

const DocumentTitle = styled<any, any>('h3')`
    ${propStyles};
`;

DocumentTitle.defaultProps = {
    flex: "1 0 auto",
    fontSize: "inherit",
    fontWeight: "normal",
    margin: "0 1em 0 0"
};

@inject('dataStore')
@observer
class Document extends Component<any, any> {
    @computed
    get documentCount() {
        return this.props.documents.length;
    }

    @computed
    get selectedCount() {
        return this.props.documents.filter(document => this.props.documentSelected(document.clientCode)).length;
    }

    render() {
        const { selectedCount, documentCount } = this;
        const { theme, dataStore, documentGroupName, documents, toggleDownload, documentSelected } = this.props;

        return (
            <DocumentWrapper>
                <DocumentType
                    {...theme.DocumentType}
                >
                    <DocumentTitle
                        {...theme.DocumentTitle}
                    >
                        <Translate>{documentGroupName}</Translate>
                    </DocumentTitle>
                    {
                        documentCount > 1
                            ? (
                                <DocumentDropDown
                                    documents={documents}
                                    documentSelected={documentSelected}
                                    toggleDownload={toggleDownload}
                                    showCheckbox={true}
                                >
                                    {
                                        selectedCount > 0
                                            ? (
                                                <Translate
                                                    placeholders={{ selected: selectedCount, total: documentCount }}
                                                >
                                                    {`{selected}/{total} documents selected`}
                                                </Translate>
                                            )
                                            : (
                                                <Translate placeholders={{ total: documentCount }}>
                                                    {`{total} documents available`}
                                                </Translate>
                                            )
                                    }
                                </DocumentDropDown>
                            )
                            : (
                                <DocumentCheckboxButton
                                    label={documents[0].cultureCode}
                                    clientCode={documents[0].clientCode}
                                    selected={documentSelected(documents[0].clientCode)}
                                    downloadDocuments={dataStore.downloadDocuments}
                                    onChange={() => toggleDownload(documents[0].clientCode)}
                                    count={1}
                                    showCount={false}
                                    showCheckbox={true}
                                    bgColor="transparent"
                                    hover={{ bgColor: "transparent" }}
                                    borderStyle="none"
                                    theme={{
                                        ...theme,
                                        ...{
                                            DocumentSelectLabel: {
                                                minWidth: "0"
                                            }
                                        }
                                    }}
                                />
                            )
                    }
                </DocumentType>
            </DocumentWrapper>
        );
    }
}

export default withTheme(Document) as any;


// WEBPACK FOOTER //
// ./src/Components/Document.tsx